module.exports = __webpack_public_path__ + "img/logo-viajesmillenial.897218af.png";